import React from 'react';

const Text = ({ className }) => {
  return (
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.65745 7.87267H4.24038L3.46635 9.67315C3.27564 10.1163 3.18029 10.4472 3.18029 10.6659C3.18029 10.8398 3.26162 10.9941 3.42428 11.1287C3.59255 11.2577 3.95152 11.3418 4.5012 11.3811V11.6924H0.908654V11.3811C1.38542 11.297 1.69391 11.1876 1.83413 11.053C2.12019 10.7837 2.4371 10.2369 2.78486 9.41233L6.79808 0.0229111H7.09255L11.0637 9.5133C11.3834 10.2761 11.6723 10.7725 11.9303 11.0025C12.1939 11.2268 12.5585 11.353 13.024 11.3811V11.6924H8.52284V11.3811C8.97716 11.3586 9.28285 11.2829 9.4399 11.1539C9.60256 11.0249 9.68389 10.8679 9.68389 10.6828C9.68389 10.436 9.57172 10.0461 9.34736 9.5133L8.65745 7.87267ZM8.42188 7.25007L6.48678 2.6395L4.5012 7.25007H8.42188Z" fill="white"/>
    </svg>
  )
}

export default Text;